export default __webpack_public_path__ + "static/media/icon_drafting-compass_bleu.e015483b.svg";